import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CallSession } from '@ragu-components/ord-types';

const CallHistoryList = React.lazy(async () =>
  import('@ragu-components/ord-views').then((module) => ({ default: module.CallHistoryList }))
);

export const callHistoryResource: OrdResourceProps = {
  key: Resources['me/call_history'],
  name: Resources['me/call_history'],
  list: <CallHistoryList view='plain' />,
  options: {},
  recordRepresentation: (record: CallSession): string =>
    `${record.caller_id_name ?? ''} (${record.caller_id_number ?? ''})`,
};
